//Запоминание выбора из фиксированного набора значений в localStorage
export function createChoiceStorage({ key, allowed, fallback }) {
  return {
    set(value) {
      try {
        localStorage.setItem(key, value);
      } catch (error) {
        console.error(`Ошибка сохранения ${key}:`, error);
      }
    },

    //Чужое/устаревшее значение в localStorage не пускаем в стор — берём дефолт
    get() {
      try {
        const saved = localStorage.getItem(key);
        return allowed.includes(saved) ? saved : fallback;
      } catch (error) {
        console.error(`Ошибка чтения ${key}:`, error);
        return fallback;
      }
    },
  };
}
